<nav class="">
  <ng-container [ngTemplateOutlet]="$safeNavigationMigration(navConfig?.topSingleTemplate)"></ng-container>

  <!-- main bar -->
  @if (!navConfig?.topSingleTemplate) {
    <div class="nav">
      <div class="logo">
        @if (canGoToDashboard()) {
          <img routerLink="/dashboard" [src]="logoUrl()" class="clickable" />
        } @else {
          <img [src]="logoUrl()" />
        }
      </div>

      @if (showApplicationName() && !!environment.applicationName) {
        <span class="app-name">{{ environment.applicationName }}</span>
      }

      <ng-container [ngTemplateOutlet]="$safeNavigationMigration(navConfig?.topLeftNavTemplate)"></ng-container>
      @if (environment.environment !== 'production') {
        <top-nav-item>
          <rcp-environment-indicator [environment]="environment"> </rcp-environment-indicator>
        </top-nav-item>
      }
    </div>
  }

  <!-- align items right -->
  <div class="nav nav-right">
    <ng-container [ngTemplateOutlet]="$safeNavigationMigration(navConfig?.topRightNavTemplate)"></ng-container>

    @if (showStandaloneLogout()) {
      <top-nav-item [iconTyped]="faPowerOff" (click)="logout()"></top-nav-item>
    }
  </div>
</nav>
